<template>
    <div class="dashlet">
      <div class="mb-1 pr-0 pl-1 dashlet">
        <div class="ibox-body dashlet">
                <div class="ibox-title style_2">
                  <div class="label label-info float-right ibox-tools p-1">{{$t('navigations.last month')}}</div>
                    <h5>{{$t('navigations.overdue visits')}}</h5>
                </div>
                <div class="ibox-content contentheight">
                    <h1 class="no-margins">{{overdueCount}}</h1>
                    <small>{{$t('navigations.overdue visits')}}</small>
                </div>
            </div>
      </div>
    </div>
  </template>
  
  <script>
  /* eslint-disable */
  import axios from "axios";
  import store from "@/store";
  export default {
    name: 'overduevisits',
    data() {
    return {
      baseapi: process.env.VUE_APP_Service_URL,
      overdueCount:"",
    }
  },
  async mounted() {
    window.addEventListener("studyIdChanged", async (event) => {
      await this.Getoverduecompletedcount();
		});
    await this.Getoverduecompletedcount();
  },
    methods:{
        async  Getoverduecompletedcount(){
      const idtoken = store.getters.getIdToken;
      this.overdueCount = 0;
      const currentstuid =  store.getters.getStudyIs;
      let status = "Overdue";   
      await axios.get(`${this.baseapi}/management/patientschedule/overduecompletedcount?StudyId=${currentstuid}&DaysBefore=30&VisitStatus=${status}` , 
      {
						headers: {
							"Access-Control-Allow-Origin": "localhost:8080",
							Authorization: "Bearer " + idtoken,
							"Content-Type": "application/json",
						},
					})
      .then((res) => {
        this.overdueCount = res.data.Overdue;
      })
      .catch((err) => { console.log("error.." ,err);
      })
    },
       
    }
  };
  </script>
  
  <style>
  .dashlet{
    width:100%;
    height:100%;
  }
  .contentheight{
    height: calc(100% - 48px);
  }
</style>